export interface AeratorSubtype {
  id: number;
  name: string;
}

/**
 * Hardcoded values as this is not an endpoint we need to request almost ever.
 */
export const AeratorSubTypes: AeratorSubtype[] = [
  {
    id: 0,
    name: 'paddleWheel',
  },
  { id: 1, name: 'injection' },
  {
    id: 2,
    name: 'diffusion',
  },
];
